import React from 'react'
import {
  Box,
  TextField,
  Typography,
  Paper,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Button,
  Chip,
  Divider,
  Slider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {RoundedCorner} from '@mui/icons-material';
import  useEmailEditorStore  from '../../utilities/emailEditorStore'
import WidthWideIcon from '@mui/icons-material/WidthWide';
import { AlignHorizontalLeft, AlignHorizontalRight, AlignVerticalBottom, AlignVerticalTop } from '@mui/icons-material';
import FormatSizeIcon from '@mui/icons-material/FormatSize';

function GlobalProperties() {

     const {globalProperties,updateGlobalProperties} = useEmailEditorStore();
        const handleInputChange = (property, value) => {
            updateGlobalProperties({ [property]: value });
        };
     const handleGlobalPropertyChange = (property, value) => {
        updateGlobalProperties({ [property]: value });
      };
      const handlePaddingChange = (side, value) => {
            const newPadding = { ...globalProperties.padding, [side]: parseInt(value) || 0 };
            updateGlobalProperties({ padding: newPadding });
        };

  const handleMobilePaddingChange = (side, value) => {
    const newPadding = { ...globalProperties.mobilePadding, [side]: parseInt(value) || 0 };
    updateGlobalProperties({ mobilePadding: newPadding });
  };
    
         const handleSliderChange = (event, newValue) => {
            updateGlobalProperties({ emailBorderRadius: newValue })
            //setValue(newValue);
           // handlePropertyChange('canvasborderRadius', newValue);
         };
     // Specific handler for margin changes
  const handleMarginChange = (side, value) => {
    const currentMargin = globalProperties.margin || { top: 0, right: 0, bottom: 0, left: 0 };
    const newMargin = { ...currentMargin, [side]: parseInt(value) || 0 };
    updateGlobalProperties({ margin : newMargin});
  };
  return (
 
      <Box>
        <TextField
                label="Template Name"
                value={globalProperties.templateName}
                onChange={(e) => handleInputChange('templateName', e.target.value)}
                fullWidth
                size="small"
                variant="outlined"
                 sx={{ mb: 2 }}
          />
       
        {/* Layout Settings */}
        <Accordion  sx={{ mb: 2,backgroundColor: 'rgba(0, 0, 0, .03)' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1" sx={{ fontWeight: 400 }}>
              Layout Settings
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box>
                  <Typography variant="body2" gutterBottom>
                    Email Width
                  </Typography>
                  <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                    <Grid>
                      <WidthWideIcon />
                    </Grid>
                    <Grid size="grow">
                      <Slider
                        value={globalProperties.emailWidth || 600}
                        onChange={(e, value) => handleInputChange('emailWidth', value)}
                        aria-labelledby="input-slider-email-width"
                        step={1}
                        marks
                        max={1000}
                        min={250}
                      />
                    </Grid>
                    <Grid>
                      <Typography variant="body2" gutterBottom>
                       {globalProperties.emailWidth || 600} px
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

             
              
              <Box>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                  Email Background Color
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  <input
                    type="color"
                    value={globalProperties.backgroundColor}
                    onChange={(e) => handleInputChange('backgroundColor', e.target.value)}
                    style={{ 
                      width: 40, 
                      height: 40, 
                      border: '1px solid #ccc', 
                      borderRadius: 4,
                      cursor: 'pointer'
                    }}
                  />
                  <TextField
                    value={globalProperties.backgroundColor}
                    onChange={(e) => handleInputChange('backgroundColor', e.target.value)}
                    size="small"
                    variant="outlined"
                    sx={{ flexGrow: 1 }}
                  />
                </Box>
              </Box>
               <Box>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                  Canvas Background Color
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  <input
                    type="color"
                    value={globalProperties.emailBackgroundColor}
                    onChange={(e) => handleInputChange('emailBackgroundColor', e.target.value)}
                    style={{ 
                      width: 40, 
                      height: 40, 
                      border: '1px solid #ccc', 
                      borderRadius: 4,
                      cursor: 'pointer'
                    }}
                  />
                  <TextField
                    value={globalProperties.emailBackgroundColor}
                    onChange={(e) => handleInputChange('emailBackgroundColor', e.target.value)}
                    size="small"
                    variant="outlined"
                    sx={{ flexGrow: 1 }}
                  />
                </Box>
              </Box>
              {/** Padding */}
              <Box>
                          <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                            Padding
                          </Typography>
                          <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid>
                              <AlignVerticalTop />
                            </Grid>
                            <Grid size="grow">
                              <Slider
                                value={globalProperties.padding?.top || 0}
                                onChange={(e, value) => handlePaddingChange('top', value)}
                                aria-labelledby="input-slider-padding-top"
                                step={1}
                                marks
                                max={80}
                                min={0}
                              />
                            </Grid>
                            <Grid>
                              <Typography variant="body2" gutterBottom>
                                {globalProperties.padding?.top || 0} px
                              </Typography>
                            </Grid>
                          </Grid>
              
                          <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid>
                              <AlignHorizontalRight />
                            </Grid>
                            <Grid size="grow">
                              <Slider
                                value={globalProperties.padding?.right || 0}
                                onChange={(e, value) => handlePaddingChange('right', value)}
                                aria-labelledby="input-slider-padding-right"
                                step={1}
                                marks
                                max={80}
                                min={0}
                              />
                            </Grid>
                            <Grid>
                              <Typography variant="body2" gutterBottom>
                                {globalProperties.padding?.right || 0} px
                              </Typography>
                            </Grid>
                          </Grid>
              
                          <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid>
                              <AlignVerticalBottom />
                            </Grid>
                            <Grid size="grow">
                              <Slider
                                value={globalProperties.padding?.bottom || 0}
                                onChange={(e, value) => handlePaddingChange('bottom', value)}
                                aria-labelledby="input-slider-padding-bottom"
                                step={1}
                                marks
                                max={80}
                                min={0}
                              />
                            </Grid>
                            <Grid>
                              <Typography variant="body2" gutterBottom>
                                {globalProperties.padding?.bottom || 0} px
                              </Typography>
                            </Grid>
                          </Grid>
              
                          <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid>
                              <AlignHorizontalLeft />
                            </Grid>
                            <Grid size="grow">
                              <Slider
                                value={globalProperties.padding?.left || 0}
                                onChange={(e, value) => handlePaddingChange('left', value)}
                                aria-labelledby="input-slider-padding-left"
                                step={1}
                                marks
                                max={80}
                                min={0}
                              />
                            </Grid>
                            <Grid>
                              <Typography variant="body2" gutterBottom>
                                {globalProperties.padding?.left || 0} px
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
              {/** Padding End */}
              {/** Margin Start */}
              {/* Margin */}
                        <Box>
                          <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                            Margin
                          </Typography>
                          <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid>
                              <AlignVerticalTop />
                            </Grid>
                            <Grid size="grow">
                              <Slider
                                value={globalProperties.margin?.top || 0}
                                onChange={(e, value) => handleMarginChange('top', value)}
                                aria-labelledby="input-slider-margin-top"
                                step={1}
                                marks
                                max={80}
                                min={0}
                              />
                            </Grid>
                            <Grid>
                              <Typography variant="body2" gutterBottom>
                                {globalProperties.margin?.top || 0} px
                              </Typography>
                            </Grid>
                          </Grid>
              
                         
              
                          <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid>
                              <AlignVerticalBottom />
                            </Grid>
                            <Grid size="grow">
                              <Slider
                                value={globalProperties.margin?.bottom || 0}
                                onChange={(e, value) => handleMarginChange('bottom', value)}
                                aria-labelledby="input-slider-margin-bottom"
                                step={1}
                                marks
                                max={80}
                                min={0}
                              />
                            </Grid>
                            <Grid>
                              <Typography variant="body2" gutterBottom>
                                {globalProperties.margin?.bottom || 0} px
                              </Typography>
                            </Grid>
                          </Grid>
              
                        
                        </Box>
              {/** Margin End */}
                <Box>
                     <Typography variant="body2" gutterBottom>
                        Canvas Border Radius
                        </Typography>
                        <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid>
                                <RoundedCorner />
                            </Grid>
                            <Grid size="grow">
                            <Slider
                                value={globalProperties.emailBorderRadius}
                                onChange={handleSliderChange}
                                aria-labelledby="input-slider"
                                step={4}
                                marks
                                max= {40}
                            />
                            </Grid>
                            <Grid>
                                <Typography variant="body2" gutterBottom>
                                   {globalProperties.emailBorderRadius} px
                                </Typography>
                            </Grid>
                            
                    </Grid>
                </Box>


            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Typography Settings */}
        <Accordion  sx={{ mb: 2,backgroundColor: 'rgba(0, 0, 0, .03)' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1" sx={{ fontWeight: 400 }}>
              Typography
            </Typography>
          </AccordionSummary>
          <AccordionDetails>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Font Family</InputLabel>
                <Select
                  value={globalProperties.fontFamily}
                  onChange={(e) => handleInputChange('fontFamily', e.target.value)}
                  label="Font Family"
                >
                  <MenuItem value="Arial, sans-serif">Arial</MenuItem>
                  <MenuItem value="Georgia, serif">Georgia</MenuItem>
                  <MenuItem value="'Times New Roman', serif">Times New Roman</MenuItem>
                  <MenuItem value="'Courier New', monospace">Courier New</MenuItem>
                  <MenuItem value="Helvetica, sans-serif">Helvetica</MenuItem>
                  <MenuItem value="'Trebuchet MS', sans-serif">Trebuchet MS</MenuItem>
                </Select>
              </FormControl>
               <Box>
                  <Typography variant="body2" gutterBottom>
                    Font Size
                  </Typography>
                  <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                    <Grid>
                      <FormatSizeIcon />
                    </Grid>
                    <Grid size="grow">
                      <Slider
                        value={globalProperties.fontSize || 16}
                        onChange={(e, value) => handleInputChange('fontSize', value)}
                        aria-labelledby="input-slider-font-size"
                        step={1}
                        marks
                        max={48}
                        min={10}
                      />
                    </Grid>
                    <Grid>
                      <Typography variant="body2" gutterBottom>
                        {globalProperties.fontSize || 16} px
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
             
              
              <TextField
                label="Line Height"
                type="number"
                step="0.1"
                value={globalProperties.lineHeight}
                onChange={(e) => handleInputChange('lineHeight', parseFloat(e.target.value) || 1.4)}
                fullWidth
                size="small"
                variant="outlined"
              />
              
              <Box>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                  Text Color
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  <input
                    type="color"
                    value={globalProperties.color}
                    onChange={(e) => handleInputChange('color', e.target.value)}
                    style={{ 
                      width: 40, 
                      height: 40, 
                      border: '1px solid #ccc', 
                      borderRadius: 4,
                      cursor: 'pointer'
                    }}
                  />
                  <TextField
                    value={globalProperties.color}
                    onChange={(e) => handleInputChange('color', e.target.value)}
                    size="small"
                    variant="outlined"
                    sx={{ flexGrow: 1 }}
                  />
                </Box>
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Mobile Settings */}
        <Accordion sx={{ mb: 2,backgroundColor: 'rgba(0, 0, 0, .03)' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1" sx={{ fontWeight: 400 }}>
              Mobile Settings
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                label="Mobile Breakpoint (px)"
                type="number"
                value={globalProperties.mobileBreakpoint}
                onChange={(e) => handleInputChange('mobileBreakpoint', parseInt(e.target.value) || 480)}
                fullWidth
                size="small"
                variant="outlined"
              />
              
              <TextField
                label="Mobile Email Width"
                value={globalProperties.mobileEmailWidth}
                onChange={(e) => handleInputChange('mobileEmailWidth', e.target.value)}
                fullWidth
                size="small"
                variant="outlined"
              />
              {/** MobilePadding Start */}
               <Box>
                          <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                           Mobile Padding
                          </Typography>
                          <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid>
                              <AlignVerticalTop />
                            </Grid>
                            <Grid size="grow">
                              <Slider
                                value={globalProperties.mobilePadding?.top || 0}
                                onChange={(e, value) => handleMobilePaddingChange('top', value)}
                                aria-labelledby="input-slider-mobile-padding-top"
                                step={1}
                                marks
                                max={80}
                                min={0}
                              />
                            </Grid>
                            <Grid>
                              <Typography variant="body2" gutterBottom>
                                {globalProperties.mobilePadding?.top || 0} px
                              </Typography>
                            </Grid>
                          </Grid>
              
                          <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid>
                              <AlignHorizontalRight />
                            </Grid>
                            <Grid size="grow">
                              <Slider
                                value={globalProperties.mobilePadding?.right || 0}
                                onChange={(e, value) => handleMobilePaddingChange('right', value)}
                                aria-labelledby="input-slider-mobile-padding-right"
                                step={1}
                                marks
                                max={80}
                                min={0}
                              />
                            </Grid>
                            <Grid>
                              <Typography variant="body2" gutterBottom>
                                {globalProperties.mobilePadding?.right || 0} px
                              </Typography>
                            </Grid>
                          </Grid>
              
                          <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid>
                              <AlignVerticalBottom />
                            </Grid>
                            <Grid size="grow">
                              <Slider
                                value={globalProperties.mobilePadding?.bottom || 0}
                                onChange={(e, value) => handleMobilePaddingChange('bottom', value)}
                                aria-labelledby="input-slider-mobile-padding-bottom"
                                step={1}
                                marks
                                max={80}
                                min={0}
                              />
                            </Grid>
                            <Grid>
                              <Typography variant="body2" gutterBottom>
                                {globalProperties.mobilePadding?.bottom || 0} px
                              </Typography>
                            </Grid>
                          </Grid>
              
                          <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid>
                              <AlignHorizontalLeft />
                            </Grid>
                            <Grid size="grow">
                              <Slider
                                value={globalProperties.mobilePadding?.left || 0}
                                onChange={(e, value) => handleMobilePaddingChange('left', value)}
                                aria-labelledby="input-slider-mobile-padding-left"
                                step={1}
                                marks
                                max={80}
                                min={0}
                              />
                            </Grid>
                            <Grid>
                              <Typography variant="body2" gutterBottom>
                                {globalProperties.mobilePadding?.left || 0} px
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
              {/** Mobile Padding End */}
              
            </Box>
          </AccordionDetails>
        </Accordion>

         {/* Email Content Settings */}
        <Accordion sx={{ mb: 2,backgroundColor: 'rgba(0, 0, 0, .03)' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1" sx={{ fontWeight: 400 }}>
              Email Content
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
             
             
              <TextField
                label="Preheader Text"
                value={globalProperties.preheaderText}
                onChange={(e) => handleInputChange('preheaderText', e.target.value)}
                fullWidth
                size="small"
                variant="outlined"
               
              />
               <TextField
                label="Footer Text"
                value={globalProperties.footerText}
                onChange={(e) => handleInputChange('footerText', e.target.value)}
                fullWidth
                size="small"
                variant="outlined"
               
              />
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
   
  )
}

export default GlobalProperties